export default "__VITE_ASSET__nEkImUbh__"